import { Filter, FilterFamily, Filters, Value } from "PFTypes";

const mapFilters = <INPUT extends Filter | Value, OUTPUT extends Filter | Value>(
  filters: Record<string, INPUT>,
  mapper: (filter: INPUT, filterKey: string) => OUTPUT
): Record<string, OUTPUT> =>
  Object.entries(filters).reduce(
    (res, [filterKey, filter]) => ({
      ...res,
      [filterKey]: mapper(filter, filterKey)
    }),
    {}
  );

export const mapValuesInFilterGroup = <INPUT extends Filter | Value, OUTPUT extends Filter | Value>(
  filters: Filters<INPUT>,
  mapperProvider: (familyFilterKey: FilterFamily) => (filter: INPUT, filterKey: string) => OUTPUT
): Filters<OUTPUT> => {
  const { children: childrenFilters, ...rootFilters } = filters;
  const rootFiltersMapped = Object.entries(rootFilters).reduce(
    (result, [familyFilterKey, familyFilters]) => ({
      ...result,
      [familyFilterKey]: mapFilters<INPUT, OUTPUT>(
        familyFilters,
        mapperProvider(familyFilterKey as FilterFamily)
      )
    }),
    {}
  );
  return {
    ...rootFiltersMapped,
    children: childrenFilters ? mapValuesInFilterGroup(childrenFilters, mapperProvider) : undefined
  };
};
